import { useResource, useResourceRelationship } from 'datx-jsonapi-react';
import { useRouter } from 'next/router';
import { FC, Fragment, ReactNode, useMemo } from 'react';

import { NonPublicTicketCheck } from '@/components/ui/shared/overlays/NoTicketCheck/components/NonPublicTicketCheck';
import { NAVIGATION_ITEMS } from '@/constants/event-app-navigation-items';
import { queryThinEvent, queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';

import { NoTicketLoader } from './components/NoTicketLoader';
import { checkIsEventPagePublic } from './NoTicketCheck.utils';

interface INoTicketCheckProps {
  eventId: string;
  children?: ReactNode;
}

export const NoTicketCheck: FC<INoTicketCheckProps> = ({ eventId, children }) => {
  const router = useRouter();

  const { data: event, error: eventError } = useResource(queryThinEvent(eventId));

  const { data: eventConfiguration } = useResourceRelationship<EventConfiguration>(
    queryThinEventConfigurationRelationship(eventId)
  );

  const isPublic = useMemo(
    () => eventConfiguration && checkIsEventPagePublic(NAVIGATION_ITEMS, router.asPath, eventConfiguration),
    [router, eventConfiguration]
  );

  if (!event && !eventError) return <NoTicketLoader />;

  if (isPublic) return <Fragment>{children}</Fragment>;

  return <NonPublicTicketCheck event={event}>{children}</NonPublicTicketCheck>;
};
